export interface FirmDocumentDialogFileNameItem {
  key: string;
  fileName: string;
}

export const getFirmDocumentDialogFileNameItems = (fileNames: string[]): FirmDocumentDialogFileNameItem[] => {
  const fileNameCounts = new Map<string, number>();

  return fileNames.map(fileName => {
    const occurrence = (fileNameCounts.get(fileName) ?? 0) + 1;
    fileNameCounts.set(fileName, occurrence);

    return {
      fileName,
      key: occurrence === 1 ? fileName : `${fileName}-${occurrence}`,
    };
  });
};
